import * as React from "react";
const SvgIcBatteryHigh = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M14 8V16H17V8H14ZM20 5V9H22V15H20V19H0V5H20Z" fill="currentColor" /></svg>;
export default SvgIcBatteryHigh;